import CircularProgress from '@mui/material/CircularProgress';

export const Loader = ({isButton}) => {
  return (
    isButton
      ? <><CircularProgress size="1rem" sx={{mr: '.7rem'}} />Loading...</>
      : <div className="loading"><CircularProgress size='1.2rem' />Loading...</div>
  )
};
